import Error from '../model/Error';
import Stationery from '../dto/Stationery';
import axios from 'axios';

export default class StationeryRepository {

    static findSimpleByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/stationeries`, {  })
                .then(response => resolve(response.data.data.map(data => Stationery.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findInvoiceByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/invoice-stationeries`, {  })
                .then(response => resolve(response.data.data.map(data => Stationery.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(stationeryId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/stationeries/${stationeryId}`, {  })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
